import { render, staticRenderFns } from "./addPrice.vue?vue&type=template&id=6a15dd22&"
import script from "./addPrice.vue?vue&type=script&lang=js&"
export * from "./addPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports